import templateUtils from './templateUtils';
import * as _ from 'lodash';
function mapSiteStyles(compStyles) {
    var siteColors = compStyles.siteColors, siteTextPresets = compStyles.siteTextPresets, colors = compStyles.colors, fonts = compStyles.fonts, numbers = compStyles.numbers;
    var mappedColors = templateUtils.mapColors(siteColors, colors);
    var mappedFonts = templateUtils.mapFonts(fonts);
    var mappedNumbers = templateUtils.mapNumbers(numbers);
    return {
        mappedColors: mappedColors,
        mappedFonts: mappedFonts,
        siteTextPresets: siteTextPresets,
        mappedNumbers: mappedNumbers,
    };
}
function getFirstOrFallbackStyleParamValue(mappedCompStyles, match, p1) {
    var optionsOrder = p1.trim().split(' ');
    for (var i = 0; i < optionsOrder.length; i++) {
        var value = optionsOrder[i];
        var font = _.get(mappedCompStyles.mappedFonts[value], 'value');
        var color = _.get(mappedCompStyles.mappedColors[value], 'value');
        var number = mappedCompStyles.mappedNumbers[value];
        var text = _.get(mappedCompStyles.siteTextPresets[value], 'value');
        var firstVal = _.chain({ font: font, color: color, number: number, text: text })
            .omitBy(_.isUndefined)
            .values()
            .head()
            .value();
        if (firstVal) {
            return firstVal;
        }
        if (i === optionsOrder.length - 1) {
            return optionsOrder[i];
        }
    }
    return p1;
}
function applyTheme(styleTemplate, compStyles) {
    var mappedCompStyles = mapSiteStyles(compStyles);
    return styleTemplate.replace(/\{{2}([^}|^{]*)\}{2}/gim, _.partial(getFirstOrFallbackStyleParamValue, mappedCompStyles));
}
export { applyTheme };
//# sourceMappingURL=styleUtils.js.map